import React from "react";
import styled from "styled-components";
import { Table as BsTable } from "react-bootstrap";
import { RespuestaLeerPropietarios } from "../../../services/propietariosServicios";

interface TableSectionProps {
  propietarios: RespuestaLeerPropietarios[];
  onPropietarioClick: (propietario: RespuestaLeerPropietarios) => void;
}

interface TableItemProps {
  propietario: RespuestaLeerPropietarios;
  onPropietarioClick: (propietario: RespuestaLeerPropietarios) => void;
}

function TableItem({ propietario, onPropietarioClick }: TableItemProps) {
  return (
    <StyledRow
      onClick={() => {
        onPropietarioClick(propietario);
      }}
    >
      <StyledCell>{propietario.nombres}</StyledCell>
      <StyledCell>{propietario.email}</StyledCell>
      <StyledCell>{propietario.mascotas.join(", ")}</StyledCell>
    </StyledRow>
  );
}

function PropietariosTable({
  propietarios,
  onPropietarioClick,
}: TableSectionProps) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>Nombres</StyledColHeader>
          <StyledColHeader>Email</StyledColHeader>
          <StyledColHeader>Mascotas</StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {propietarios.map((_, index) => (
          <TableItem
            key={_.id}
            propietario={_}
            onPropietarioClick={onPropietarioClick}
          />
        ))}
      </tbody>
    </StyledTable>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

export default PropietariosTable;
